import {useCallback} from 'react';
import {
  PolarAngleAxis,
  PolarGrid,
  Radar,
  RadarChart,
  ResponsiveContainer,
} from 'recharts';
import styled from 'styled-components';
import {KodataCustomerGenderAgeData} from '@/map/@types';
import {AGE_GENDER_SUBJECTS} from '@/map/constants';
import {palette} from '@/styles';

export interface IProps {
  data: KodataCustomerGenderAgeData;
}

export const AgeGenderRadarChart = ({data}: IProps) => {
  const getChartData = useCallback(() => {
    if (data?.maleAgeGender && data?.femaleAgeGender) {
      const chartData: {subject: string; male: number; female: number}[] =
        data.maleAgeGender.map((item, index) => {
          return {
            subject: AGE_GENDER_SUBJECTS[index],
            male: Math.round(item * 10) / 10 || 0,
            female: data.femaleAgeGender
              ? Math.round(data.femaleAgeGender[index] * 10) / 10
              : 0,
          };
        });

      return chartData;
    }
  }, [data]);

  if (!data) {
    return null;
  }

  const chartData = getChartData();

  return (
    <Root>
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={chartData}>
          <PolarGrid stroke={palette.gray150} strokeWidth={0.8} />
          <PolarAngleAxis
            dataKey="subject"
            tick={{fill: palette.gray400, fontSize: 10}}
          />
          <Radar
            name="male"
            dataKey="male"
            stroke={palette.blue400}
            fill={palette.blue400}
            fillOpacity={0.1}
          />
          <Radar
            name="female"
            dataKey="female"
            stroke={palette.red400}
            fill={palette.red400}
            fillOpacity={0.1}
          />
        </RadarChart>
      </ResponsiveContainer>
    </Root>
  );
};

const Root = styled.div`
  height: 216px;
`;
